import React from 'react';
const facts = [{
  value: '6 + 5',
  label: 'Volumes & bonuses'
}, {
  value: '300',
  label: 'Print-ready pages'
}, {
  value: '43',
  label: 'Ready-to-run practices'
}, {
  value: '27',
  label: 'Printable worksheets'
}];

// Bandas de bloque del producto (B1 Chalk sobre navy · B2 Clay · B3 Green · B4 Optic Yellow)
const accents = ['before:bg-ice', 'before:bg-clay', 'before:bg-green', 'before:bg-gold'];
export function SocialProofBar() {
  return <section className="w-full bg-navy" data-id="element-282" data-mp="32gqsopznp2zb">
      <div className="max-w-6xl mx-auto px-5 pb-14 pt-10 sm:pb-16" data-id="element-283" data-mp="2xjs1af7dna4t">
        <div className="grid grid-cols-2 gap-px overflow-hidden rounded-xl border border-navy-line bg-navy-line sm:grid-cols-4" data-id="element-284" data-mp="2tier5sx94ks3">
          {facts.map((fact, i) => <div key={fact.label} className={`relative bg-navy px-4 py-5 text-center before:absolute before:inset-x-0 before:top-0 before:h-1 before:content-[''] ${accents[i]}`} data-id="element-285" data-mp="2oj27fh1ofttq" data-mpi={i}>
              <div className="font-display text-4xl sm:text-5xl leading-none text-gold" data-id="element-286" data-mp="1d6j7lzdhrmm0">
                {fact.value}
              </div>
              <div className="mt-1.5 text-[10px] font-bold uppercase tracking-widest text-white/60" data-id="element-287" data-mp="1dnntb7nitu6i">
                {fact.label}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}